// extracted by mini-css-extract-plugin
export default {"title":"page-header_title__TElbh"};